import React from 'react';
import Layout from './Components/Layout';
import styles from './styles/Pages.module.css';

export default function PrivacyPolicy() {
  return (
    <div className={styles.container}>
      <Layout 
         title="Privacy Policy - MyChineseHoroscope.com"
  description="Read the privacy policy of MyChineseHoroscope. Learn how we protect your information and ensure your date of birth and personal data are not stored or shared."
  keywords="privacy policy, data protection, mychinesehoroscope, user privacy, personal information, date of birth privacy"
  imageUrl="https://mychinesehoroscope.com/my-chinese-horoscope-finder.png" 
  schemaType="WebPage"
  schemaData={{
    datePublished: "2025-08-05",
    authorName: "MyChineseHoroscope"
  }}>
        <main className={styles.main}>
          <h1 className={styles.title}>Privacy Policy</h1>

          <h2>Privacy Policy for MyChineseHoroscope</h2>
          <i className={styles.center}>
            This Privacy Policy explains how MyChineseHoroscope collects, uses, and protects your personal information when you use our website, www.mychinesehoroscope.com.
          </i>

          <p>
            MyChineseHoroscope is committed to safeguarding your privacy and ensuring the security of any personal information you provide. We strictly adhere to privacy laws and principles to protect your data.
          </p>

          <h3>Collection of Your Personal Information</h3>
          <p>
            While you may enter your date of birth or other information to find your Chinese Zodiac sign, please note that <strong>we do not save or store your date of birth or any personally identifiable information</strong>. The data entered is used only temporarily to generate your horoscope results and is not retained, sold, or shared for any other purposes.
          </p>
          <p>
            We collect only non-personally identifiable information automatically when you visit our site, such as browser type, operating system, pages visited, and traffic data. This information is used solely to improve user experience and website performance.
          </p>

          <h3>Use of Your Personal Information</h3>
          <p>
            Any data you provide (such as date of birth) is processed immediately to provide horoscope results and is never stored. We do not use your personal information for marketing, profiling, or any form of targeted advertising.
          </p>

          <h3>Sharing of Your Personal Information</h3>
          <p>
            MyChineseHoroscope does not share your personal information with third parties. Since we do not retain your date of birth or personally identifiable data, there is no risk of unauthorized sharing or use.
          </p>

          <h3>Changes to This Privacy Policy</h3>
          <p>
            We reserve the right to update or modify this Privacy Policy at any time. Any changes will be posted on this page with an updated revision date. Please review this policy periodically to stay informed about how we protect your information.
          </p>

          <h3>Contact Us</h3>
          <p>
            If you have any questions or concerns about this Privacy Policy, please contact us at: <a href="mailto:info@mychinesehoroscope.com">info@mychinesehoroscope.com</a>.
          </p>
        </main>
      </Layout>
    </div>
  );
}

export async function getStaticProps() {
  return {
    props: {},
    revalidate: 1,
  };
}
